import { render, staticRenderFns } from "./sidebarMobile.vue?vue&type=template&id=088638bc&scoped=true"
import script from "./sidebarMobile.vue?vue&type=script&lang=js"
export * from "./sidebarMobile.vue?vue&type=script&lang=js"
import style0 from "./sidebarMobile.vue?vue&type=style&index=0&id=088638bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088638bc",
  null
  
)

export default component.exports